import { render, staticRenderFns } from "./SearchHistoryTable.vue?vue&type=template&id=a2f71580&"
import script from "./SearchHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./SearchHistoryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports